import { Box } from "@mui/material";
import { ReactNode } from "react";

export function MortgagesStickySidebar(params: {
    enabled: boolean,
    children: ReactNode,
}) {
    return (
        <Box
            sx={{
                position: params.enabled ? "sticky" : "static",
                top: params.enabled ? 16 : "auto",
                zIndex: params.enabled ? 10 : "auto",
                backgroundColor: params.enabled ? "background.paper" : "transparent",
                borderRadius: params.enabled ? 1 : 0,
            }}
        >
            {params.children}
        </Box>
    );
}
